import { createFileRoute } from '@tanstack/react-router';
import DeImpressum from '@/pages/legal/DeImpressum';
import { routeHead } from '@/lib/seo/route-head';

export const Route = createFileRoute('/de/impressum/')({
  head: () => routeHead('/de/impressum/'),
  component: DeImpressum,
});